export const faqs = [
  {
    q: '瓜田黑料的内容主要讲什么？',
    a: '我们专注于娱乐热点的"时间线复盘"与"舆论观察"，把公开的、可查证的物料按时间排列，梳理事件的来龙去脉和传播路径，帮助读者在信息密集的热点里快速建立整体认知。',
  },
  {
    q: '你们会发布未经证实的个人隐私信息吗？',
    a: '不会。我们只梳理当事人或相关方公开发布的内容，以及媒体已公开报道的信息。任何需要核实才能成立的说法，我们都会明确标注为"待核实"，不会当作事实呈现。',
  },
  {
    q: '为什么同样一件事，你们的时间线和别处不一样？',
    a: '因为多数流传版本只截取了情绪最强的那一段。我们的做法是把前后节点都保留下来，包括容易被忽略的预热、澄清和后续动作，所以看起来会更完整，也更接近事件本身的结构。',
  },
  {
    q: '可以投稿或提供线索吗？',
    a: '可以。在"联系我们"页面提交链接、截图或事件描述即可。我们更欢迎带有原始发布时间和来源的完整材料，这会大幅提升核实效率。',
  },
  {
    q: '文章多久更新一次？',
    a: '常规更新节奏是每周三到四篇深度复盘，遇到大型热点会临时加更。你可以在专题列表页按分类筛选，快速找到感兴趣的方向。',
  },
  {
    q: '你们会给出"谁对谁错"的结论吗？',
    a: '一般不会。舆论事件很少是非黑即白的判断题。我们提供的是时间线、公开材料和分析框架，结论留给你自己判断。',
  },
];

export default faqs;